import {getFormData, resetFormErrors, showFormErrors, showInputError} from '../utils/form';
import {handleCaptcha, initCaptcha, resetCaptcha} from '../utils/captcha';
import trans from '../utils/trans';
import * as notification from '../components/notifications';
import Tagify from '@yaireo/tagify';
import {initTextEditor, getTextEditorInstance, typeHtmlIntoEditor} from "../utils/editor";
import {initCustomFieldsTagsInput, setCustomFieldsData} from "../utils/custom_fields";
import {reportEmployerRegisteredEvent, reportEmployerPostedJobEvent} from "../utils/analytics";
import * as rc from "../utils/rc";
import $jsAPI from "../front_end_api";
import {getFormattedDateWithTranslatedMonth} from "../utils/helpers";

const $jBoard = window.$jBoard;
const editingJob = window.editingJob;
const products = window.products || null;
const defaultProduct = window.defaultProduct || null;
const preselectedProduct = window.preselectedProduct || null;
const existingEmployerProducts = window.existingEmployerProducts || null;

let job = window.job ? window.job : null;
let expireInDaysInitialValue = null;

const getProductById = (productId) => {
  if (!products){
    return null;
  }

  return products.find(product => product.id == productId);
};

const getEmployerProduct = (employerProductId) => {
  if (!existingEmployerProducts){
    return null;
  }

  return existingEmployerProducts.find(employerProduct => employerProduct.id == employerProductId);
};

const sendSaveJobRequest = async (data) => {
  let response;
  if (!job) {
    data.draft = false;
    response = await axios.post("/api/jobs", data);
  } else {
    response = await axios.put("/api/jobs/" + job.id, data);
  }

  expireInDaysInitialValue = $("[name='job_expires_in_days']", getJobDetailsForm()).val();
  job = response.data;

  return job;
};

// ###############################################################################################################################################
// ########################## Step 1: Company Details ############################################################################################
// ###############################################################################################################################################

const sendCompanyDetailsRequest = async (data) => {
  let response = await axios.post("/register", data);
  return response.data;
};

const getCompanyDetailsForm = () => {
  return $("#form-company-details");
};

const getCompanyDetailsFormData = () => {
  const companyDetailsForm = getCompanyDetailsForm();
  const data = getFormData(companyDetailsForm);

  if (data.custom_fields) {
    data.custom_fields = setCustomFieldsData(data.custom_fields, companyDetailsForm.attr('id'));
  }

  return data;
};

const initCompanyDetailsTab = () => {
  const companyDetailsForm = getCompanyDetailsForm();
  if (companyDetailsForm.hasClass('simple-submit-form')) {
    return;
  }

  $jsAPI.fireEvent('employer:registration_form_opened')

  initCaptcha(() => {
    saveCompanyDetails();
  });

  companyDetailsForm.submit(handleCaptcha(
    (e) => {
      saveCompanyDetails();

      return false;
    }
  ));
};

const saveCompanyDetails = async () => {
  const data = getCompanyDetailsFormData();
  const form = getCompanyDetailsForm();

  $('.btn-submit', form).loading();

  try {
    const {user, employer} = await sendCompanyDetailsRequest(data);

    reportEmployerRegisteredEvent();

    resetFormErrors(form);
    $('.btn-submit', form).loading(false);

    const redirectUrl = form.attr('data-success-redirect');
    $jsAPI.fireEvent('employer:registered', user, employer)
    window.location.replace(redirectUrl);
  } catch (e) {
    console.log('error', e);
    $('.btn-submit', form).loading(false);
    showFormErrors(form, e.response);
  }

  resetCaptcha();
}



// ###############################################################################################################################################
// ########################## Step 2 : Job Details ###############################################################################################
// ###############################################################################################################################################

const saveJob= async () => {
  const data =getJobDetailsFormData();
  const form = getJobDetailsForm()

  $('.btn-submit', form).loading();

  try {
    let newJob = job === null;

    job = await sendSaveJobRequest(data);

    resetFormErrors(form);

    if (editingJob) {
      $('.btn-submit', form).loading(false);
      notification.success(trans('post_job.message.update.success'));
      return;
    }
    let postAJobUrl = rc.getPostAJobPageUrl();
    let employerAccountJobsPageUrl = rc.getEmployerAccountJobPageUrl();

    if (newJob) {
      $jsAPI.fireEvent('job:new_job_details_submitted', job);
    }

    if (job.product_not_purchased) {

      let redirectUrl = null;
      if (defaultProduct) {
        let productIdParam = null;
        if (preselectedProduct) {
          productIdParam = `&preselectedProductId=${preselectedProduct.id}`;
        } else {
          productIdParam = `&productId=${defaultProduct.id}`;
        }

        redirectUrl = `${postAJobUrl}/payment?jobId=${job.id}${productIdParam}`
      } else {
        redirectUrl = `${postAJobUrl}/select-product?jobId=${job.id}`;
      }

      window.location.replace(redirectUrl);
    } else {
      reportEmployerPostedJobEvent();
      window.location.replace(`${employerAccountJobsPageUrl}`);
    }
  } catch (e) {
    console.log('error', e);

    $('.btn-submit', form).loading(false);
    showFormErrors(form, e.response);
  }
};

const getJobDetailsFormData = () => {
  const jobDetailsForm = getJobDetailsForm();
  const data = getFormData(jobDetailsForm);

  data.remote = !!data.remote;

  data.tags = data.tags !== undefined && data.tags !== '' ? JSON.parse(data.tags).map(function(tag){
    return tag.value;
  }) : [];

  data.draft = false;

  if (data.custom_fields) {
    data.custom_fields = setCustomFieldsData(data.custom_fields, jobDetailsForm.attr('id'));
  }

  return mergeWithJobData(data);
};

const mergeWithJobData = (data) => {
  if (job && typeof job.tags !== 'undefined') {
    job.tags = job.tags.map(function(tag){
      return tag.name ?? tag;
    });
  }

  const jobDataMergedWithFormData = {
    ...(job ? job : {}),
    ...data,
  };

  /**
   * If the job_expires_in_days data is not changed we don't send it,
   * because during the form editing it might happen that the day is changed,
   * and in fact we send not correct data, because if refreshed the form data will be changed.
   * Ex: input value is 30, a day is passed during working on the form, REFRESH and input value is 29
   */
  if (jobDataMergedWithFormData.job_expires_in_days === expireInDaysInitialValue) {
    delete jobDataMergedWithFormData['job_expires_in_days'];
  }

  return jobDataMergedWithFormData;
};

const getJobDetailsForm = () => {
  return $("#form-job-details");
};

const initApplySection = () => {
  $("#v-apply-by").change(function(){
    const selectedOption = $(this).val();
    if (selectedOption === 'by_link') {
      $(".apply-by-link-text").show();
      $(".apply-by-email-text").hide();
      $("#v-apply-to").show();
      $("#v-apply-to").attr('placeholder', $("#v-apply-to").data('link-placeholder'));
    } else if (selectedOption === 'by_email') {
      $(".apply-by-link-text").hide();
      $(".apply-by-email-text").show();
      $("#v-apply-to").show();
      $("#v-apply-to").attr('placeholder', $("#v-apply-to").data('email-placeholder'));
    } else {
      $(".apply-by-link-text").hide();
      $(".apply-by-email-text").hide();
      $("#v-apply-to").hide();
    }

    $(".apply-by-help").hide();
    $("#text-apply-by-help-"+selectedOption).show();
  });

  $("#v-apply-by").change();
};

const observeExpirationDaysChange = () => {
  const expirationDaysInput = $("[name='job_expires_in_days']", getJobDetailsForm());
  showTheExpirationDate(expirationDaysInput.val());

  expirationDaysInput.on("input", function () {
    showTheExpirationDate($(this).val());
  });
}

const showTheExpirationDate = (expiresInDaysValue) => {
  expiresInDaysValue = +(expiresInDaysValue);
  if (isNaN(expiresInDaysValue)) {
    return;
  }

  if (expiresInDaysValue === 0) {
    $('#job-expires-in-days-help-text', getJobDetailsForm()).text("");
    return;
  }

  let willExpireOnDateHelpText = trans('post_job.form.job_expires_in_days.help.will_expire_in_days');
  willExpireOnDateHelpText = willExpireOnDateHelpText.
                                 replace(':DATE', getFormattedDateWithTranslatedMonth((new Date).getDate() + expiresInDaysValue));
  $('#job-expires-in-days-help-text', getJobDetailsForm()).text(willExpireOnDateHelpText)
}

// Kept so the AI job description writer can prefill AI-picked tags (postJob.js
// owns the only Tagify instance on the job details form).
let jobTagsTagify = null;

const initTagsInput = () => {
  let inputElm = $('#job-tags')[0];

  if (!inputElm) {
    return;
  }

  const isInitiated = $(inputElm).attr('is-initiated');

  if (isInitiated) {
    return;
  }

  $(inputElm).attr('is-initiated', true);

  const maxTags = parseInt(inputElm.dataset.maxTags, 10) || 15;
  const suggestionsPerPage = 100;
  const allowCreateTags = inputElm.dataset.allowCreateTags != 0;
  let allTagsTotal = 0;
  let lastResultsTotal = 0;

  let whitelist = $.map(inputElm.value.trim().split(/\s*,\s*/), function (tag) {
    return {
      value: tag,
      editable: false
    }
  });
  let source;

  let tagifyProps = {
    whitelist: whitelist,
    keepInvalidTags: true,
    maxTags: maxTags,
    dropdown: {
      maxItems: suggestionsPerPage
    }
  }

  const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  // Makes Tagify open the dropdown even when nothing matches,
  // rendering this row in place of the suggestions
  tagifyProps.templates = {
    dropdownItemNoMatch(suggestion) {
      const noResultsHtml = `<div class="jb-tags-dd-no-match-title">${trans('post_job.form.job_tags.dropdown.no_results', {QUERY: escapeHtml(suggestion.value)})}</div>`;

      if (!allowCreateTags) {
        return `<div class="jb-tags-dd-empty">${noResultsHtml}</div>`;
      }

      return `<div class='${this.settings.classNames.dropdownItem} jb-tags-dd-no-match' tabindex="0" role="option">${noResultsHtml}<div class="jb-tags-dd-meta">${trans('post_job.form.job_tags.dropdown.press_enter_to_add')}</div></div>`;
    }
  };

  if (!allowCreateTags) {
    tagifyProps.enforceWhitelist = true;
    tagifyProps.skipInvalid = true;
  }

  let tagify = new Tagify(inputElm, tagifyProps);
  jobTagsTagify = tagify;

  const dropdownElm = tagify.DOM.dropdown;

  const dropdownHeader = document.createElement('div');
  dropdownHeader.className = 'tagify__dropdown__header';
  dropdownHeader.innerHTML = '<span class="jb-tags-dd-meta jb-tags-dd-title" data-dd-title></span>' +
    '<span class="jb-tags-dd-meta" data-dd-showing></span>';
  dropdownElm.insertBefore(dropdownHeader, dropdownElm.content);

  const dropdownFooter = document.createElement('div');
  dropdownFooter.className = 'tagify__dropdown__footer';
  let dropdownFooterHtml = '<span class="jb-tags-dd-meta" data-dd-search-hint></span>';
  if (allowCreateTags) {
    dropdownFooterHtml += `<span class="jb-tags-dd-meta jb-tags-dd-keys"><kbd>enter</kbd> ${trans('post_job.form.job_tags.dropdown.enter_to_add')}</span>`;
  }
  dropdownFooter.innerHTML = dropdownFooterHtml;
  dropdownElm.appendChild(dropdownFooter);

  const updateDropdownMeta = (query) => {
    const shown =  tagify.settings.dropdown.maxItems;
    const noMatches = Boolean(query) && lastResultsTotal === 0;
    const hintElm = dropdownFooter.querySelector('[data-dd-search-hint]');
    const keysElm = dropdownFooter.querySelector('.jb-tags-dd-keys');

    const resultsTotal = Math.max(lastResultsTotal, shown);

    dropdownHeader.querySelector('[data-dd-title]').textContent = query
      ? trans('post_job.form.job_tags.dropdown.search_results')
      : trans('post_job.form.job_tags.dropdown.most_used');
    // Only worth showing when some results did not fit into the dropdown
    dropdownHeader.querySelector('[data-dd-showing]').textContent = !noMatches && resultsTotal > shown
      ? trans('post_job.form.job_tags.dropdown.showing', {
          SHOWN: shown,
          TOTAL: resultsTotal
        })
      : '';

    hintElm.textContent = !query && allTagsTotal > shown
      ? trans('post_job.form.job_tags.dropdown.type_to_search', {TOTAL: allTagsTotal})
      : '';

    if (keysElm) {
      keysElm.style.display = noMatches ? 'none' : '';
    }

    dropdownFooter.style.display = hintElm.textContent || (allowCreateTags && !noMatches) ? '' : 'none';
  };

  tagify.DOM.input.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !tagify.state.dropdown.visible || !allowCreateTags) {
      return;
    }

    const highlightedElm = dropdownElm.querySelector('.' + tagify.settings.classNames.dropdownItemActive);

    if (highlightedElm && !highlightedElm.classList.contains('jb-tags-dd-no-match')) {
      return;
    }

    const typedText = tagify.state.inputText.trim();

    if (!typedText) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    tagify.addTags(typedText, true);
    tagify.dropdown.hide.call(tagify);
  });

  dropdownElm.addEventListener('click', (event) => {
    if (event.target.closest('.jb-tags-dd-no-match')) {
      tagify.addTags(tagify.state.inputText, true);
      tagify.dropdown.hide.call(tagify);
    }
  });

  tagify.on('input', onInput);
  tagify.DOM.input.addEventListener('focus', (e) => {
    const data = getFormData(getJobDetailsForm());

    // If there are no tags, call onInput, otherwise do nothing
    if (!data.tags.length) {
      return onInput(e);
    }
  });
  tagify.on('invalid', onInvalidTag);

  function onInput(e) {
    var value = e?.detail ? e.detail.value : '';
    tagify.settings.whitelist.length = 0;

    tagify.loading(true).dropdown.hide.call(tagify)

    source && source.cancel();
    const CancelToken = axios.CancelToken;
    source = CancelToken.source();

    axios.get($jBoard.config.main_api_url + "/tags", {
      params: {
        query: value,
        per_page: suggestionsPerPage
      },
      cancelToken: source.token
    }).then(function(response){
      let data = $.map(response.data.data, function (tag) {
        return tag.name;
      });

      lastResultsTotal = response.data.total || 0;
      if (!value) {
        allTagsTotal = lastResultsTotal;
      }

      tagify.settings.whitelist = data;
      tagify.loading(false).dropdown.show.call(tagify, value); // render the suggestions dropdown
      updateDropdownMeta(value);
    });
  }

  function onInvalidTag(e) {
    source && source.cancel();
    tagify.loading(false);
  }
};

$(function () {
  initTagsInput();

  document.addEventListener('jb.section.rendered', () => {
    initTagsInput();
  });
});

let aiDescriptionTyping = null;
let aiDescriptionGenerating = false;

const getAiDescriptionIntro = () => {
  return $('#ai-description-intro');
};

const isAiDescriptionIntroVisible = () => {
  const intro = getAiDescriptionIntro();

  return intro.length > 0 && !intro.hasClass('d-none');
};

const getAiDescriptionEditorContext = () => {
  const hiddenInput = $('#v-core_field-description', getJobDetailsForm());
  const containerId = hiddenInput.prev('div').attr('id');

  if (!hiddenInput.length || !containerId) {
    return null;
  }

  return {hiddenInput, containerId};
};

const initAiDescriptionIntro = () => {
  const intro = getAiDescriptionIntro();

  if (!intro.length) {
    return;
  }

  const form = getJobDetailsForm();
  const titleInput = $('#ai-description-intro-title');

  const revealForm = () => {
    intro.addClass('d-none');
    $('#job-details-fields').removeClass('d-none');
    $('#ai-description-continue', form).removeClass('d-flex').addClass('d-none');
    $('#job-details-step-actions', form).removeClass('d-none');
  };

  const continueWithAi = () => {
    if (aiDescriptionGenerating) {
      return;
    }

    resetFormErrors(intro);

    const title = titleInput.val().trim();
    $('#v-core_field-title', form).val(title);
    generateAiDescription(title, revealForm);
  };

  form.on('submit', (e) => {
    if (isAiDescriptionIntroVisible()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      continueWithAi();
      return false;
    }

    if (aiDescriptionTyping) {
      aiDescriptionTyping.complete();
    }
  });
};

const applyAiJobAttributes = (draft) => {
  const form = getJobDetailsForm();

  const setSelectValue = (name, value) => {
    if (!value) {
      return;
    }

    const select = $('select[name="' + name + '"]', form);
    if (!select.length) {
      return;
    }

    if (typeof select.selectpicker === 'function') {
      select.selectpicker('val', String(value));
    } else {
      select.val(String(value));
    }

    select.parent('.bootstrap-select').find('.filter-option-inner-inner').removeClass('empty-value');
  };

  setSelectValue('category_id', draft.category_id);
  setSelectValue('job_type_id', draft.job_type_id);

  if (jobTagsTagify && Array.isArray(draft.tags) && draft.tags.length) {
    jobTagsTagify.settings.whitelist = draft.tags.slice();
    jobTagsTagify.addTags(draft.tags);
  }
};

const getAiDescriptionStatusElement = () => {
  return $('#ai-description-status');
};

const generateAiDescription = async (title, revealForm) => {
  const continueBtn = $('#ai-description-continue');

  aiDescriptionGenerating = true;
  continueBtn.loading();

  let draft = null;
  try {
    draft = (await axios.post('/api/job_description_drafts', {title})).data;
  } catch (e) {
    const errors = e.response && e.response.status === 422 && e.response.data ? e.response.data.errors : null;

    if (errors && errors.title) {
      aiDescriptionGenerating = false;
      continueBtn.loading(false);
      showInputError($('#ai-description-intro-title'), errors.title[0]);
      return;
    }
  }

  aiDescriptionGenerating = false;
  continueBtn.loading(false);
  revealForm();

  if (!draft) {
    return;
  }

  applyAiJobAttributes(draft);
  typeAiDescription(draft.description);
};

const typeAiDescription = (html) => {
  const editorContext = getAiDescriptionEditorContext();
  const quill = editorContext ? getTextEditorInstance(editorContext.containerId) : null;

  if (!quill) {
    return;
  }

  const status = getAiDescriptionStatusElement();
  editorContext.hiddenInput.closest('.jb-rich-text-editor').before(status);
  status.removeClass('d-none');

  let scrollTo = status.offset().top - 90;
  const headerNavBar = $('header .fixed-top');
  if (headerNavBar.length > 0) {
    scrollTo -= headerNavBar.height();
  }
  $([document.documentElement, document.body]).animate({scrollTop: Math.max(scrollTo, 0)}, 500);

  quill.disable();

  const cleanUp = () => {
    status.addClass('d-none');
    quill.enable();
    aiDescriptionTyping = null;
  };

  $('.ai-jd-status-stop', status).on('click', (e) => {
    e.preventDefault();

    if (aiDescriptionTyping) {
      aiDescriptionTyping.stop();
    }
  });

  aiDescriptionTyping = typeHtmlIntoEditor(editorContext.containerId, html, {
    interval: 12,
    chunkSize: 2,
    onDone: () => cleanUp(),
  });

  if (!aiDescriptionTyping) {
    cleanUp();
  }
};

const initJobPostingTab = () => {
  initTextEditor('quill-container-with-job-details');
  initAiDescriptionIntro();
  initApplySection();
  expireInDaysInitialValue = $("[name='job_expires_in_days']", getJobDetailsForm()).val();
  observeExpirationDaysChange();

  if (!job) {
    $jsAPI.fireEvent('job:new_job_posting_form_opened')
  }

  getJobDetailsForm().submit(() => {
    saveJob();

    return false;
  });
};

// ###############################################################################################################################################
// ########################## Step 3 : Select Product View ########################################################################################
// ###############################################################################################################################################

const getEmployerProductsForm = () => {
  return $("#form-select-product");
};

const showProductDetails = (product) => {
  $('#modal-product-information').modal('show');
  $('#modal-product-information .modal-body').html(product.description);
};

const useEmployerProduct = async (employerProductId, btn) => {
  $jsAPI.fireEvent('products:pre_purchased_product_selected', getEmployerProduct(employerProductId))

  const form = getEmployerProductsForm();

  let data = {
    employer_product_id: employerProductId,
    draft: false,
  };

  data = mergeWithJobData(data);
  $(btn).loading(true);

  try {
    job = await sendSaveJobRequest(data);

    resetFormErrors(form);

    const redirectUrl = form.data('success-redirect');

    reportEmployerPostedJobEvent();

    window.location.replace(redirectUrl);

    $(btn, form).loading(false);
  } catch (e) {
    console.log('error', e);

    $(btn, form).loading(false);
    showFormErrors(form, e.response);
  }
};

const postAJobUsingPreselectedEmployerProduct = async (employerProductId, btn) => {
  let data = getJobDetailsFormData();
  const form = getJobDetailsForm()

  data = {
    ...data,
    employer_product_id: employerProductId,
    draft: false,
  };

  $(btn).loading(true);

  let newJob = job === null;

  try {
    job = await sendSaveJobRequest(data);

    resetFormErrors(form);

    reportEmployerPostedJobEvent();
    let employerAccountJobsPageUrl = rc.getEmployerAccountJobPageUrl();

    if (newJob) {
      $jsAPI.fireEvent('job:new_job_details_submitted', job, getEmployerProduct(employerProductId));
    }

    window.location.replace(employerAccountJobsPageUrl);

    $(btn, form).loading(false);
  } catch (e) {
    console.log('error', e);

    $(btn, form).loading(false);
    showFormErrors(form, e.response);
  }
};

const initPostUsingPreselectedEmployerProduct = () => {

  if (!$('#post-using-preselected-employer-product-id').length) {
    return;
  }

  $('#post-using-preselected-employer-product-id').click(function(){
    let employerProductId = $(this).data('employerProductId');
    postAJobUsingPreselectedEmployerProduct(employerProductId, this);
    return false;
  });
}

const initSelectProductView = () => {
  $(".buy-product-card .job-posting-select-product-cta").click(function() {
    const formProductElem = $(this).parents('.form-product');
    if (formProductElem.hasClass('buy-product-card')) {
      const product = getProductById(formProductElem.data('productId'));
      $jsAPI.fireEvent('products:new_product_selected', product, job);
    }
  });

  $(".product-name, .view-product-details").click(function() {
     const formProductElem = $(this).parents('.form-product');
     if (formProductElem.hasClass('buy-product-card')) {
        const product = getProductById(formProductElem.data('productId'));
        showProductDetails(product);
     } else {
       const employerProduct = getEmployerProduct(formProductElem.data('employerProductId'));
       showProductDetails(employerProduct.product);
     }

     return false;
  });

  $('.use-product-btn').click(function(){
    let employerProductId = $(this).data('id');
    useEmployerProduct(employerProductId, this);
    return false;
  });
};

// #####################################################################################################################
// ################################ Global Code / UI  ##################################################################
// #####################################################################################################################

const initPage = () => {
  if (getCompanyDetailsForm().length) {
    initCompanyDetailsTab();
    initCustomFieldsTagsInput();
    return;
  }

  if (getJobDetailsForm().length) {
    initJobPostingTab();
    initCustomFieldsTagsInput();
    initPostUsingPreselectedEmployerProduct();
    return;
  }

  if (getEmployerProductsForm().length) {
    initSelectProductView();
  }
};

$(initPage);
